// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-hover-table .ant-table .ant-table-tbody > tr:hover > td {
    background: transparent none repeat 0 0 / auto auto padding-box border-box scroll;
    background: initial;
}

.normal-cursor {
  cursor: default;
}

.custom-hover-table-box {
  height: 45px;
}

.unread {
  background: rgba(255,255,255,0.7);
}

.read {
  background: rgba(147, 146, 146, 0.10);
}

.custom-table-selection > div > div > div {
  border: none;
}

.custom-table-selection .ant-table-tbody > tr.ant-table-row-selected td {
  color: inherit;
}


.custom-table-header .ant-table-thead > tr > th .ant-table-header-column {
  display: block;
  max-width: 100%;
}


.custom-table-height .ant-checkbox {
  padding: 4px 8px !important;
}

.custom-table-header .ant-table-thead > tr > th .ant-table-header-column {
  display: block;
  max-width: 100%;
/*  background-color: #03112c;*/
}

.custom-table-header-blood {
  display:block;
  height: 90vh;
  overflow-y: auto;
  overflow-x: hidden;
}
.custom-table-header-blood .ant-table-thead {
  width: 100%;
}

.custom-table-header-blood .ant-table-tbody {
  width: 100%;
}

.custom-table-header-blood .ant-table-thead > tr > th {
  background-color: #03112c;
  padding:9px 8px;
  white-space:pre-wrap;
  text-overflow: ellipsis;
  font-size: 0.9vw;
}

.custom-table-header-blood .ant-table-tbody > tr > td {
  padding:9px 8px;
  color: white;
  white-space:pre-wrap;
  text-overflow: ellipsis;
  font-size: 0.8vw;
}

.custom .ant-checkbox {
  padding: 1px !important;
  height: 10px !important;
  width: 10px !important;
}

@media only screen and (max-width: 1800px) and (min-width: 1601px) {
  .custom-table-header-blood .ant-table-tbody > tr > td {
    padding:9px 8px;
  }
  .custom-table-header-blood .ant-table-thead > tr > th {
    padding:9px 8px;
  }
}

@media only screen and (max-width: 1600px) and (min-width: 1401px) {
  .custom-table-header-blood .ant-table-tbody > tr > td {
    padding:8px 6px;
    font-size: 1vw;
  }
  .custom-table-header-blood .ant-table-thead > tr > th {
    padding:8px 6px;
    font-size: 1vw;
  }
}

@media only screen and (max-width: 1400px) and (min-width: 1200px) {
  .custom-table-header-blood .ant-table-tbody > tr > td {
    padding:8px 4px;
    font-size: 1.1vw;
  }
  .custom-table-header-blood .ant-table-thead > tr > th {
    padding:8px 4px;
    font-size: 1.1vw;
  }
}

@media only screen and (max-width: 1199px) {
  .custom-table-header-blood .ant-table-tbody > tr > td {
    padding:8px 1px;
    font-size: 1.2vw;
  }
  .custom-table-header-blood .ant-table-thead > tr > th {
    padding:8px 1px;
    font-size: 1.2vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/asset/style/custom_antd_table_style.css"],"names":[],"mappings":"AAAA;IACI,iFAAiF;IACjF,mBAAmB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;;AAGA;EACE,cAAc;EACd,eAAe;AACjB;;;AAGA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB,+BAA+B;AAC/B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,cAAc;EAChB;EACA;IACE,eAAe;IACf,cAAc;EAChB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;AACF","sourcesContent":[".custom-hover-table .ant-table .ant-table-tbody > tr:hover > td {\n    background: transparent none repeat 0 0 / auto auto padding-box border-box scroll;\n    background: initial;\n}\n\n.normal-cursor {\n  cursor: default;\n}\n\n.custom-hover-table-box {\n  height: 45px;\n}\n\n.unread {\n  background: rgba(255,255,255,0.7);\n}\n\n.read {\n  background: rgba(147, 146, 146, 0.10);\n}\n\n.custom-table-selection > div > div > div {\n  border: none;\n}\n\n.custom-table-selection .ant-table-tbody > tr.ant-table-row-selected td {\n  color: inherit;\n}\n\n\n.custom-table-header .ant-table-thead > tr > th .ant-table-header-column {\n  display: block;\n  max-width: 100%;\n}\n\n\n.custom-table-height .ant-checkbox {\n  padding: 4px 8px !important;\n}\n\n.custom-table-header .ant-table-thead > tr > th .ant-table-header-column {\n  display: block;\n  max-width: 100%;\n/*  background-color: #03112c;*/\n}\n\n.custom-table-header-blood {\n  display:block;\n  height: 90vh;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n.custom-table-header-blood .ant-table-thead {\n  width: 100%;\n}\n\n.custom-table-header-blood .ant-table-tbody {\n  width: 100%;\n}\n\n.custom-table-header-blood .ant-table-thead > tr > th {\n  background-color: #03112c;\n  padding:9px 8px;\n  white-space:pre-wrap;\n  text-overflow: ellipsis;\n  font-size: 0.9vw;\n}\n\n.custom-table-header-blood .ant-table-tbody > tr > td {\n  padding:9px 8px;\n  color: white;\n  white-space:pre-wrap;\n  text-overflow: ellipsis;\n  font-size: 0.8vw;\n}\n\n.custom .ant-checkbox {\n  padding: 1px !important;\n  height: 10px !important;\n  width: 10px !important;\n}\n\n@media only screen and (max-width: 1800px) and (min-width: 1601px) {\n  .custom-table-header-blood .ant-table-tbody > tr > td {\n    padding:9px 8px;\n  }\n  .custom-table-header-blood .ant-table-thead > tr > th {\n    padding:9px 8px;\n  }\n}\n\n@media only screen and (max-width: 1600px) and (min-width: 1401px) {\n  .custom-table-header-blood .ant-table-tbody > tr > td {\n    padding:8px 6px;\n    font-size: 1vw;\n  }\n  .custom-table-header-blood .ant-table-thead > tr > th {\n    padding:8px 6px;\n    font-size: 1vw;\n  }\n}\n\n@media only screen and (max-width: 1400px) and (min-width: 1200px) {\n  .custom-table-header-blood .ant-table-tbody > tr > td {\n    padding:8px 4px;\n    font-size: 1.1vw;\n  }\n  .custom-table-header-blood .ant-table-thead > tr > th {\n    padding:8px 4px;\n    font-size: 1.1vw;\n  }\n}\n\n@media only screen and (max-width: 1199px) {\n  .custom-table-header-blood .ant-table-tbody > tr > td {\n    padding:8px 1px;\n    font-size: 1.2vw;\n  }\n  .custom-table-header-blood .ant-table-thead > tr > th {\n    padding:8px 1px;\n    font-size: 1.2vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
